export default __webpack_public_path__ + "static/media/spinWheel.00115b22.png";